import { BaseApi, enhanceOpt } from '../couplingAjax'
import { Services } from '@/store/StoreTypes'
import vuex from '@/store/index'

const Biz_api = (request: typeof BaseApi, SERVIVE: Services) => {
  return {
    srcmLogin: {
      //创建企业及游客登录
      CreateAndLogin: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/register`,
          method: 'post',
        }),
      //登录
      Login: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/login?sessionId=${sessionId}`,
          method: 'post',
        }),
      LoginV2: (opt: enhanceOpt, sessionId: string) =>
        request({
          ...opt,
          url: `/login/v2?sessionId=${sessionId}`,
          method: 'post',
        }),
      // 注册
      personalRegister: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/personalRegister`,
          method: 'post',
        }),
      // 注册-合规版
      personalRegisterV2: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/personalRegisterV2`,
          method: 'post',
        }),
      // 邮箱注册
      emailRegister: (opt: enhanceOpt) =>
        request({
          ...opt,
          url: `/register`,
          method: 'post',
        }),
      queryDurationBalance: (opt: enhanceOpt) => {
        return request({
          ...opt,
          url: `/corp/listAccountV3`,
          method: 'post',
        })
      },
      fetchAiDrawTimes: (opt: enhanceOpt) => {
        return request({
          ...opt,
          url: `/client/balance`,
          method: 'post',
          headers: {
            token: vuex.state.user.token,
          },
        })
      },
      AddLog: (userId: string) =>
        request({
          url: `/addLoginLog?userId=${userId}`,
          method: 'get',
        }),
      UserOperationLog: (opt: enhanceOpt) =>
        request({
          url: `/userOperationLog`,
          method: 'post',
          ...opt,
        }),
    },
  }
}

export default Biz_api
